import Vue from 'vue';
import _ from 'lodash';
import App from './App.vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
Vue.use(Vuex);
import { store } from './store/store';

import Antd from 'ant-design-vue';
import VueMasonry from 'vue-masonry-css';
import VueClipboard from 'vue-clipboard2';
import VueTextareaAutosize from 'vue-textarea-autosize';
import SweetModal from 'sweet-modal-vue/src/plugin.js';
import VueTelInput from 'vue-tel-input';
import VueTypedJs from 'vue-typed-js';
import VueInputAutowidth from 'vue-input-autowidth';
import VuePapaParse from 'vue-papa-parse';

import 'ant-design-vue/dist/antd.css';

import { routes } from './router/routes';

Vue.prototype._ = _;

Vue.use(Antd);
Vue.use(VueMasonry);
Vue.use(VueClipboard);
Vue.use(VueTextareaAutosize);
Vue.use(SweetModal);
Vue.use(VueTelInput);
Vue.use(VueTypedJs);
Vue.use(VueInputAutowidth);
Vue.use(VuePapaParse);

Vue.config.productionTip = false

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
